import React from 'react';
import PlacementBanner from './PlacementsSection/PlacementBanner';
import Success from './Success/Success';
import Gallery from './Gallery/Gallery';
import Opportunities from '../BarManagementSection/Opportunities/Opportunities';
import Companies from '../Home/Companies/Companies';

function Placements() {
  return (
    <>

      <PlacementBanner/>
      <Companies/>
      <Success/>
      <Opportunities/>
      <Gallery/>
    </>
  )
}

export default Placements
